// Polyfill Node.js `global` for browser (webpack did this automatically, Vite does not)
if (typeof global === 'undefined') {
    (window as any).global = globalThis;
}
